module.exports = __webpack_public_path__ + "public/img/昨日安灯次数统计.fc0ba59d.png";